import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { BaseDataResource } from '@/modules/core/app/resources/BaseDataResource';
import { GenericDataModel } from '@/modules/core/app/models/GenericDataModel';
import { GenericModel } from '@/modules/core/app/models/GenericModel';
import { DISTINCT_VALUES } from '@/modules/ta/widget/widget.constants';

export class LineItemDataResource extends BaseDataResource {
  constructor() {
    super(RouteGroup.LINEITEMS);
  }

  async getWidgetData(widget, params, config = {}) {
    const data = await this.getOtherDataSourcesData('', '', params, config);
    return this.extractData(data, GenericDataModel, params);
  }

  /**
   *
   * @param serviceId
   * @param dataViewId
   * @param fields
   * @param params
   * @returns {Promise<*>}
   */
  async getValuesDistinct(serviceId, dataViewId, fields, params = {}) {
    params = { ...params, fields };
    return super.getDataValues(GenericModel, DISTINCT_VALUES, params);
  }
}

export default new LineItemDataResource();
